import { TaskStatus } from '@exam-management/graphql';
import { FilterButtonGroup } from '@shared/components';

import { useMyTaskSearchParams } from '../../hooks';

const TASK_STATUS_OPTIONS = [
  { label: 'Todo', value: TaskStatus.Todo },
  { label: 'In Progress', value: TaskStatus.InProgress },
  { label: 'Done', value: TaskStatus.Completed },
];

export default function TaskStatusButtonGroup() {
  const [{ status }, { changeStatus }] = useMyTaskSearchParams();

  const handleStatusChange = (value: TaskStatus) => {
    changeStatus(value);
  };

  return (
    <FilterButtonGroup
      items={TASK_STATUS_OPTIONS}
      onChange={(value) => handleStatusChange(value as TaskStatus)}
      value={status}
    />
  );
}
